import { TeamResponse } from '../client';
import { useTeamContext } from '../TeamContext';

export const useTeam = (): TeamResponse => {
  const { teamName } = useTeamContext();
  return { name: teamName };
};
